export const PublicLeadKinds = {
  Callback: 'callback',
  GiftCertificate: 'gift_certificate',
  ActivateCertificate: 'activate_certificate',
  CompanyBenefit: 'company_benefit',
  Partnership: 'partnership',
  Feedback: 'feedback',
  Vacancy: 'vacancy',
  BirthdayClient: 'birthday_client',
  BirthdayEmployee: 'birthday_employee',
  ForeignRegistration: 'foreign_registration',
} as const;

export type PublicLeadKind =
  (typeof PublicLeadKinds)[keyof typeof PublicLeadKinds];

export interface PublicLeadApiConfig {
  apiUrl: string;
}

export interface CreatePublicLeadContact {
  phone: string;
  name?: string;
  rating?: number;
  promocode?: string;
  discount_percent?: number;
}

export interface CreatePublicLeadRequest {
  kind: PublicLeadKind;
  page_path?: string;
  service_type?: string;
  service_id?: string;
  context_lines?: string[];
  title: string;
  message?: string;
  /** Yandex Metrika ClientID (`_ym_uid`) for offline CRM conversion tracking. */
  ym_client_id?: string;
  contact: CreatePublicLeadContact;
}
